const charsExclude = ['-', '+', 'e', 'E', ',', '.'];

const charsInclude = [
  '-',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'Tab',
  'Delete',
  'Backspace',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  // "Control",
];

export const onKeyDown = (event) => {
  const key = event.key;
  // console.log("🚀 ~ TextInput ~ key:", key);
  if (charsExclude.includes(key) || !charsInclude.includes(key)) {
    event.preventDefault();
  }
};

export const onPaste = (event) => {
  const pasteData = event.clipboardData.getData('text');
  if (charsExclude.some((char) => pasteData.includes(char))) {
    event.preventDefault();
  }
};
